import { ThreeView } from "../View3dWebCad";
import * as marietta from '../../..';
import * as THREE from 'three';
import { webcadDefines } from "..";
import { EventDispatcher } from "three/src/core/EventDispatcher";
import { ObjectType } from "../ObjectType";

// export type selectType = 'innerWall' | 'ceiling' | 'floor' | 'site'

export class ObjectSelectManager extends EventDispatcher {
    public enabled: boolean = true;
    public target: THREE.Object3D;
    public intersectPoint: THREE.Vector3;
    public type: webcadDefines.extraSubTypes;
    public normal: THREE.Vector3;

    private pointObject: THREE.Object3D;

    public previousStatus: State;

    constructor() {
        super();
    }

    private hit(hitObj: THREE.Intersection[]) {
        this.target = null;
        if (hitObj.length <= 0) return;

        // const selectManager = ThreeView.get().selectManager;
        const object = hitObj[0].object;
        const innerWall = () => {
            return (ObjectType.isWall(object) || ObjectType.isKosiWall(object))
                    && ObjectType.isInnerWall(object);
        };

        const outerWall = () => {
            return (ObjectType.isWall(object) || ObjectType.isKosiWall(object))
                    && ObjectType.isOuterWall(object);
        };

        const falling = () => {
            return ObjectType.isFalling(object) && ObjectType.isFallingWall(object);
        };

        const ceiling = () => {
            return ObjectType.isCeiling(object) && ObjectType.isCeiling_(object);
        };

        const girder =() => {
            return ObjectType.isGirder(object) && ObjectType.isGirder_(object);
        }

        const floor = () => {
            return ObjectType.isFloor(object) && ObjectType.isFloor_(object);
        };

        const site = () => {
            return ObjectType.isSite(object);
        }

        const isEffectObject = (object: THREE.Object3D) : boolean => {
            let ua = marietta.webcad.WebCADGlobal.userAgentManager;
            if (!ua.isMobile && !ua.isTablet) return false;
            return ThreeView.get().wallEffect.match(<THREE.Mesh>object);
        }

        if (innerWall()) {
            if (isEffectObject(object)) return;
            this.target =  object;
            this.intersectPoint = hitObj[0].point;
            this.normal = hitObj[0].face.normal;
            this.type = webcadDefines.ExtrasSubType.INNERWALL;
        }
        // else if (outerWall()) {
        //     this.target =  object;
        //     this.intersectPoint = hitObj[0].point;
        //     this.normal = hitObj[0].face.normal;
        //     this.type = webcadDefines.ExtrasSubType.OUTWALL;
        // }        
        else if (falling()) {
            this.target =  object;
            this.intersectPoint = hitObj[0].point;
            this.normal = hitObj[0].face.normal;
            this.type = webcadDefines.ExtrasSubType.FALLINGWALL;
        }
        else if (ceiling()) {
            if (isEffectObject(object)) return;
            this.target =  object;
            this.intersectPoint = hitObj[0].point;
            this.normal = hitObj[0].face.normal;
            this.type = webcadDefines.ExtrasSubType.CEILING;
        }
        else if (girder()) {
            if (isEffectObject(object)) return;
            this.target =  object;
            this.intersectPoint = hitObj[0].point;
            this.normal = hitObj[0].face.normal;
            this.type = webcadDefines.ExtrasSubType.GIRDER;
        }
        else if (floor()) {
            if (isEffectObject(object)) return;
            this.target =  object;
            this.intersectPoint = hitObj[0].point;
            this.normal = hitObj[0].face.normal;
            this.type = webcadDefines.ExtrasSubType.FLOOR;
        }
        else if (site()) {
            this.target =  object;
            this.intersectPoint = hitObj[0].point;
            this.normal = hitObj[0].face.normal;
            this.type = webcadDefines.ExtrasSubType.GROUND;
        }
        return;
    }

    public down = () => {
        if (!this.enabled) return;

        if (this.previousStatus) this.previousStatus.execute_down();
        this.previousStatus = new downState(this);
    }

    // moveの処理
    public move() {
        if (!this.enabled) return;
        if (this.previousStatus) this.previousStatus.execute_move();
        this.previousStatus = new moveState(this);
    }

    public up = (hitObj: THREE.Intersection[]) => {
        if (!this.enabled) return;
        this.hit(hitObj);
        if (this.previousStatus) this.previousStatus.execute_up();
        this.previousStatus = new upState(this);
    }

    public reset() {
        this.unselect();
        ThreeView.get().wcScene.me.remove(this.pointObject);
    }

    public select() {
        console.log(this.target);
        this.dispatchEvent( { type: webcadDefines.WebCadEventNames.selectedObject, object: this.target, point: this.intersectPoint, selectType: this.type } );
        this.target = null;
    }

    public unselect() {
        this.target = null;
    }
}

// move: hover
// down 形状選択　→ up: select (選択状態の形状以外を選択の時)
// down 形状選択　→ move（選択状態の形状だった場合）: drag → up: dragend
// down 形状選択（選択状態の形状以外）・非選択　→ move: パン
// down 形状非選択　→　up: unSelect

class State {

    public ObjectSelectManager: ObjectSelectManager;

    constructor(ObjectSelectManager: ObjectSelectManager) {
        this.ObjectSelectManager = ObjectSelectManager;
    }

    public execute_down() {}
    public execute_move() {}
    public execute_up() {}
}

class downState extends State {
    constructor(ObjectSelectManager: ObjectSelectManager) {
        super(ObjectSelectManager);
    }

    public execute_up() {
        // 選択
        if (this.ObjectSelectManager.target) {
            this.ObjectSelectManager.select();
        } else {
            // 非選択
            this.ObjectSelectManager.unselect();
        }
    }
}

class moveState extends State {
    constructor(public ObjectSelectManager: ObjectSelectManager) {
        super(ObjectSelectManager);
    }
}

class upState extends State {
    constructor(public ObjectSelectManager: ObjectSelectManager) {
        super(ObjectSelectManager);
    }
}
